import { helpers, ts } from '_core';

export default {
  [ts.enums.REPORT_ENUMS.TABLE_SHEET_KEY_ENUM.MAIN]: [
    {
      key: 'build_date',
      name: 'Universe Date',
      filter: 'date',
      formatter: helpers.tabularFormatters.formatTo('date', { align: 'right', format: 'YYYY-MM-DD' }),
      category: 'Dates',
    },
    {
      key: 'ticker',
      name: 'Ticker',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Asset Information',
    },
    {
      key: 'name',
      name: 'Security Name',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Asset Information',
    },
    {
      key: 'asset',
      name: 'Asset',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Asset Information',
    },
    {
      key: 'isin',
      name: 'ISIN',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      condition: (features: ts.types.organization.OrganizationFeatures) => !features.hide_isin_col,
      category: 'Asset Information',
    },
    {
      key: 'cusip',
      name: 'CUSIP',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      condition: (features: ts.types.organization.OrganizationFeatures) => !features.hide_cusip_col,
      category: 'Asset Information',
    },
    {
      key: 'asset_type',
      name: 'Asset Type',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'center' }),
      filter: 'string',
      category: 'Asset Information',
    },
    {
      key: 'quotation_country',
      name: 'Quotation Country',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'center' }),
      filter: 'string',
      category: 'Geographic Data',
    },
    {
      key: 'issuer_country',
      name: 'Issuer Country',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'center' }),
      filter: 'string',
      category: 'Geographic Data',
    },
    {
      key: 'rbics_l1_name',
      name: 'Sector',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Industry',
    },
    {
      key: 'rbics_l2_name',
      name: 'Sub-Sector',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Industry',
    },
    {
      key: 'rbics_l3_name',
      name: 'Industry',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Industry',
    },
    {
      key: 'rbics_l4_name',
      name: 'Sub-Industry',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'left' }),
      filter: 'string',
      category: 'Industry',
    },
    {
      key: 'currency',
      name: 'Currency',
      formatter: helpers.tabularFormatters.formatTo('string', { align: 'center' }),
      filter: 'string',
      category: 'Financial Data',
    },
    {
      key: 'close_usd',
      name: 'Close Price',
      formatter: helpers.tabularFormatters.formatTo('float', { align: 'right', roundDigits: 2 }),
      filter: 'number',
      category: 'Financial Data',
    },
    {
      key: 'volume_usd',
      name: 'Median Volume ($M USD)',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        commasOnThousands: true,
      }),
      filter: 'number',
      category: 'Financial Data',
    },
    {
      key: 'marketcap_usd',
      name: 'Market Cap  ($M USD)',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        commasOnThousands: true,
      }),
      filter: 'number',
      category: 'Financial Data',
    },
    {
      key: '_theme_details',
      name: 'Theme Details',
      members: (key) => ['bus_seg_name', 'theme_segment', 'distance'].includes(key),
      formatter: helpers.tabularFormatters.formatDynamicTo({
        bus_seg_name: {
          colType: 'string',
          args: { align: 'left' },
        },
        theme_segment: {
          colType: 'string',
          args: { align: 'left' },
        },
        distance: {
          colType: 'float',
          args: { align: 'right', roundDigits: 2, commasOnThousands: true },
        },
        other: {
          colType: 'inferred',
        },
      }),
      nameFormatter: (key) => {
        if (key === 'bus_seg_name') return 'Company Segment';
        if (key === 'theme_segment') return 'Theme Segment';
        if (key === 'distance') return 'Distance';
        return key;
      },
      filter: 'inferred',
      category: 'Theme',
    },
    {
      key: '_handle_', // Dynamic
      name: 'Signal Filters',
      formatter: helpers.tabularFormatters.formatTo('float', {
        align: 'right',
        roundDigits: 3,
        commasOnThousands: true,
      }),
      filter: 'inferred',
      members: (key) => key.startsWith('_handle_'),
      category: 'Filters',
      cleanNameFormatter: (key, _c, resources: ts.StoreState['resources']) => {
        const handle = key.split('_handle_')[1];
        const signal = resources.signals.find((s) => s.handle === handle);
        return `${signal?.name ?? handle}`;
      },
      nameFormatter: (key, _c, resources: ts.StoreState['resources']) => {
        const handle = key.split('_handle_')[1];
        const signal = resources.signals.find((s) => s.handle === handle);
        return `${signal?.name ?? handle}`;
      },
    },
  ] as ts.types.components.dataGrid.ColumnsData,
};
